import {
	InvitationHistoryEntry,
	InvitationHistoryResponse,
} from './InviteHistoryDrawer.api';

/**
 * TEMPORARY - lets the drawer be checked before the invitation endpoints exist.
 * TODO: set USE_MOCK_HISTORY to false and delete this file once the backend is up.
 */
export const USE_MOCK_HISTORY = false;

/** flip to true to see the empty template instead of the timeline */
export const MOCK_EMPTY = false;

/** deliberately out of order - proves the drawer sorts newest first */
const MOCK_ENTRIES = [
	{
		status: 'FAILURE' as const,
		failureReason: 'כתובת המייל אינה תקינה',
		channel: 'EMAIL' as const,
		phone: null,
		email: 'israel.israeli@michpal',
		timestamp: '2025-08-09T16:05:00',
	},
	{
		status: 'SUCCESS' as const,
		failureReason: null,
		channel: 'EMAIL' as const,
		phone: null,
		email: 'israel.israeli@michpal.co.il',
		timestamp: '2025-08-11T13:50:00',
	},
	{
		status: 'SUCCESS' as const,
		failureReason: null,
		channel: 'SMS' as const,
		phone: '054-1234567',
		email: null,
		timestamp: '2025-08-10T09:12:00',
	},
	{
		status: 'FAILURE' as const,
		failureReason: 'מספר הטלפון אינו תקין',
		channel: 'SMS' as const,
		phone: '054-000',
		email: null,
		timestamp: '2025-07-30T11:20:00',
	},
	{
		status: 'SUCCESS' as const,
		failureReason: null,
		channel: 'SMS' as const,
		phone: '054-1234567',
		email: null,
		timestamp: '2025-07-28T08:00:00',
	},
	{
		status: 'SUCCESS' as const,
		failureReason: null,
		channel: 'EMAIL' as const,
		phone: null,
		email: 'israel.israeli@michpal.co.il',
		timestamp: '2025-07-21T17:45:00',
	},
	{
		status: 'FAILURE' as const,
		failureReason: 'תיבת הדואר של הנמען מלאה',
		channel: 'EMAIL' as const,
		phone: null,
		email: 'israel.israeli@michpal.co.il',
		timestamp: '2025-07-15T10:30:00',
	},
	{
		status: 'SUCCESS' as const,
		failureReason: null,
		channel: 'EMAIL' as const,
		phone: null,
		email: 'israel.israeli@michpal.co.il',
		timestamp: '2025-07-02T12:00:00',
	},
];

const LARGE_MOCK_ENTRIES: InvitationHistoryEntry[] = [
	...MOCK_ENTRIES, ...MOCK_ENTRIES, ...MOCK_ENTRIES, ...MOCK_ENTRIES, ...MOCK_ENTRIES
]

/** resolves like the real request would - with a short delay, so the spinner shows */
export const mockInvitationHistory = (
	legalId: string,
): Promise<InvitationHistoryResponse> => {
	const history: InvitationHistoryEntry[] = MOCK_EMPTY ? [] : MOCK_ENTRIES;

	return new Promise(resolve =>
		setTimeout(
			() =>
				resolve({
					userId: legalId,
					totalCount: history.length,
					history,
				}),
			1000,
		),
	);
};
